import React from 'react';
import { Pressable } from 'react-native';
import { Text } from '@tamagui/core';
import { YStack } from '@tamagui/stacks';
import { COLORS } from '@/constants/colors';
import {
  BADGE_BORDER_RADIUS,
  INFO_BUTTON_HORIZONTAL_PADDING,
  INFO_BUTTON_VERTICAL_PADDING,
  INFO_BUTTON_FONT_SIZE,
} from './constants';

type InfoButtonProps = {
  onPress: () => void;
  label: string;
};

const InfoButton: React.FC<InfoButtonProps> = ({ onPress, label }) => {
  return (
    <YStack borderRadius={BADGE_BORDER_RADIUS} overflow="hidden">
      <YStack backgroundColor={COLORS.WHITE_90}>
        <Pressable
          onPress={onPress}
          style={{
            paddingHorizontal: INFO_BUTTON_HORIZONTAL_PADDING,
            paddingVertical: INFO_BUTTON_VERTICAL_PADDING,
          }}
        >
          <Text fontSize={INFO_BUTTON_FONT_SIZE} fontWeight="700" color={COLORS.GRAY_900}>
            {label}
          </Text>
        </Pressable>
      </YStack>
    </YStack>
  );
};

export default InfoButton;
